import React from 'react';
import styled from 'styled-components';
import colors from 'assets/styles/colors';
import { fonts } from 'assets/styles/fonts';
import { refFontSize, refFontSizeLandscape, refWidth, refWidthLandscape } from '../../utils/dimensions';
import { mq } from '../../../assets/styles/mediaQuery';

const StyledButton = styled.div`
  display: flex;
  width: ${refWidth(80)}vw;
  height: ${refWidth(50)}vw;
  border-radius: ${refWidth(30)}vw;
  font-family: ${fonts.family.description};
  font-weight: ${fonts.weight.bold};
  color: ${colors.white};
  background-color: ${colors.red};
  font-size: ${refFontSize(14)}vw;
  line-height: 1em;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: ${refWidth(10)}vw;

  ${mq.landscape} {
    font-size: ${refFontSizeLandscape(14)}vw;
    width: ${refWidthLandscape(80)}vw;
    height: ${refWidthLandscape(50)}vw;
  }
`;

interface Props {
  value: string;
  onClick?: () => void;
}

const ShortButton = (props: Props) => {
  return <StyledButton onClick={props.onClick}>{props.value}</StyledButton>;
};

export default ShortButton;
